

export const LOADER_STATUS = 'boilderplate/PREPAREGSTR9C/LOADER_STATUS';
export const SET_GSTR9C_HISTORY = 'boilderplate/PREPAREGSTR9C/SET_GSTR9C_HISTORY';
export const SET_SELECTED_ROWS = 'boilderplate/PREPAREGSTR9C/SET_SELECTED_ROWS';
export const SET_SELECTED_ROW_DATA = 'boilderplate/PREPAREGSTR9C/SET_SELECTED_ROW_DATA';
export const SET_FETCH_PAGINATION = 'boilderplate/PREPAREGSTR9C/SET_FETCH_PAGINATION';

